define('ensureDate/ensureDate',[],function() {
	return function (value) {
	    var date = typeof value !== 'undefined' ? value instanceof Date ? value : new Date(value) : new Date();
	    if (isNaN(date.getTime())) {
	      throw 'ensureDate: Invalid date';
	    }
	    return date;    
	}
});
